import React from 'react';
import { View } from 'src/components/common';
import './styles.scss';

const Hourglass: React.FC<Props> = ({ zoom = 0.5 }) => {
  return (
    <View style={{ zoom }}>
      <div className="hourglass" />
    </View>
  );
};

type Props = { zoom?: number };

export default Hourglass;
